export class RegularExpressions {
  public static readonly Name = /^[A-Za-z0-9_\'\s\-\,\.]*$/;
  public static readonly LastName = /^[A-Za-z0-9_\'\s\-\,\.]*$/;
  public static readonly MiddleInitial = /^[A-Za-z0-9_\'\s\-\,\.]*$/;
  public static readonly ZipCode = /^((\d{5}-\d{4})|(\d{5})|([A-Za-z]\d[A-Za-z]\s\d[A-Za-z]\d))$/; // US 5 digit, or US 5+4 or Canadian A1A 1A1
  public static readonly SocialSecurityNumber = /^\d{3}-\d{2}-\d{4}$/;
  public static readonly Email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  public static readonly Phone = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
  public static readonly Website = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
}
